import React, { useState, useEffect } from "react";


function UpdateReviewDetails({ review, apiUrl, onClose, onUpdated, CloseForm, apiRautes, apiPostRaotes }) {
  const [data, setData] = useState({
    customerName: "",
    servicesName: "",
    serviceDate: "",
    ratingMessage: "",
    ratingNumber: null,
  });
  const [selectedValue, setSelectedValue] = useState(null);
  const [loading, setLoading] = useState(false);

  // Detect add/edit mode
  const isEdit = !!review;

  useEffect(() => {
    if (isEdit) {
      setData({
        customerName: review.customerName || "",
        servicesName: review.servicesName || "",
        serviceDate: review.serviceDate ? review.serviceDate.split("T")[0] : "",
        ratingMessage: review.ratingMessage || "",
        ratingNumber: review.ratingNumber || null,
      });
      setSelectedValue(Number(review.ratingNumber) || null);
    } else {
      setData({
        customerName: "",
        servicesName: "",
        serviceDate: "",
        ratingMessage: "",
        ratingNumber: null,
      });
      setSelectedValue(null);
    }
  }, [review, isEdit]);

  const handleFromChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSelect = (num) => {
    setSelectedValue(num);
    setData((prev) => ({ ...prev, ratingNumber: num }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedValue) {
      alert("Please select a rating");
      return;
    }

    setLoading(true);
    try {
      const method = isEdit ? "PUT" : "POST";
      const url = isEdit
        ? `${apiUrl}${apiRautes}${review._id}`
        : `${apiUrl}${apiPostRaotes}`;

      const res = await fetch(url, {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...data, rating: selectedValue }),
      });

      const result = await res.json();

      if (res.ok) {
        alert(result.message || (isEdit ? "Updated" : "Added") + " successfully");
      onUpdated?.(); // Refresh list
      onClose?.();

      CloseForm(false);
      } else {
        alert(result.message || "Something went wrong");
      }
    } catch (err) {
      console.error(err);
      alert("Server error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="view-review-details-bg">
      <div className="view-review-details-content">
        <form onSubmit={handleSubmit}>
          <div className="show-add-reviews-form-content-row">
            <input
              placeholder="Enter Customer Name"
              required
              name="customerName"
              value={data.customerName}
              onChange={handleFromChange}
            />
            <input
              placeholder="Enter Service Name"
              required
              name="servicesName"
              value={data.servicesName}
              onChange={handleFromChange}
            />
          </div>

          <div className="add-review-select-date">
            <label>Select Service Date:</label>
            <input
              type="date"
              required
              name="serviceDate"
              value={data.serviceDate}
              onChange={handleFromChange}
            />
          </div>

          <div className="show-add-rev-from-text-area">
            <textarea
              name="ratingMessage"
              value={data.ratingMessage}
              placeholder="Review message"
              rows={6}
              onChange={handleFromChange}
              required
            />
          </div>

<div className="show-add-radding-rows">
  {[1, 2, 3, 4, 5].map((num) => (
    <div
      key={num}
      className={`show-add-radding-cols ${
        Number(selectedValue) === Number(num)
          ? isEdit
            ? "selected-edit-number"
            : "selected-add-number"
          : ""
      }`}
      onClick={() => handleSelect(num)}
    >
      {num}
    </div>
  ))}




</div>



          <div className="">
            {loading ? (
              <div>Loading...</div>
            ) : (
              <div className="buttons-wrapper">
                <button type="submit" className="update-btn">
                  {isEdit ? "Update Review" : "Add Review"}
                </button>
                <button type="button" className="close-btn" onClick={()=>CloseForm(false)}>
                  Close
                </button>
              </div>
            )}
          </div>


{/* 
             <div className="add-reviews-submitn">
            {loading ? (
              <div>Loading...</div>
            ) : (
              <div className="buttons-wrapper">
                <button type="submit" className="update-btn">
                  {isEdit ? "Update Review" : "Add Review"}
                </button>
                <button
                  type="button"
                  className="close-btn"
                  onClick={() => {
                    // Reset form data and close popup
                    setData({
                      customerName: "",
                      servicesName: "",
                      serviceDate: "",
                      ratingMessage: "",
                      ratingNumber: null,
                    });
                    setSelectedValue(null);
                    onClose?.();
                  }}
                >
                  Close
                </button>
              </div>
            )}

</div> */}


        </form>
      </div>
    </div>
  );
}

export default UpdateReviewDetails;
